import React from "react";
import { useTranslation } from "react-i18next";

export const ReportingPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t('reporting.title')}</h1>
    </>
  );
};
